import React, { useState, useRef, useEffect } from 'react';
import {
  SelectContainer,
  Label,
  SelectInput,
  ChevronIcon,
  Dropdown,
  Option,
  CheckIcon,
  LabelSelected,
  LabelContainer
} from './styles';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { useDispatch } from 'react-redux';
import { StepPublishOperations } from '../../../../ducks/publish';

const SelectDropdown = ({
  label,
  options = [],
  isBranch = false,
  postingId,
  handleFieldChange,
  device,
  dataPubli = ''
}) => {
  const defaultSelected = options.find(option => option.isResponsible || option.isOwner) || options[0] || '';
  const [selected, setSelected] = useState(defaultSelected);
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const dispatch = useDispatch();

  useClickOutside(ref, setOpen);

  // Sincronizar el estado local cuando cambien las opciones
  useEffect(() => {
    const newSelected = options.find(option => option.isResponsible || option.isOwner) || options[0] || '';
    if (newSelected && newSelected.id !== selected?.id) {
      setSelected(newSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, selected?.id]);

  const handleSelect = option => {
    setSelected(option);
    setOpen(false);
    if (isBranch) {
      // Si seleccionamos otra sucursal: obtenemos créditos y responsables para esa sucursal.
      dispatch(StepPublishOperations.getCreditsOfBranch(postingId, option.id));
      handleFieldChange('branch', option.id);
    }
    if (!isBranch) {
      handleFieldChange('responsible', option.id);
    }
  };

  return (
    <SelectContainer
      device={device}
      ref={ref}
      data-publi={`professionalPubli-publishStep-selectDropdown${isBranch ? '-branch' : '-responsible'}`}
    >
      <Label data-publi={`${dataPubli}-label`}>{label}</Label>
      <SelectInput
        onClick={() => setOpen(!open)}
        open={open}
        device={device}
        data-publi={`professionalPubli-publishStep-selectDropdown${
          isBranch ? '-branch' : '-responsible'
        }-optionSelected`}
      >
        <LabelSelected device={device}>{selected ? selected.label : options[0]?.label}</LabelSelected>
        <ChevronIcon open={open} />
      </SelectInput>
      {open && (
        <Dropdown
          device={device}
          data-publi={`professionalPubli-publishStep-selectDropdown${isBranch ? '-branch' : '-responsible'}-dropdown`}
        >
          {options.map(option => (
            <Option key={option.id} onClick={() => handleSelect(option)}>
              <LabelContainer>{option.label}</LabelContainer>
              {selected?.id === option.id && <CheckIcon />}
            </Option>
          ))}
        </Dropdown>
      )}
    </SelectContainer>
  );
};

export default SelectDropdown;
